import React, { useState, useEffect } from 'react';

import axios from 'axios';

import {
    Route,
    useHistory,
    useRouteMatch,
} from 'react-router-dom';

import { Formik } from 'formik';

import styled from 'styled-components';

import { Button, Form, Row, Col } from 'react-bootstrap';

import {
    Container, CenteredTD, Header, HeaderActions, PrimaryButton, Panel, Toolbar, TableScroll, ListTable, StatusDot,
    StatusActions, FormActions, StyledTR, SideDrawer, Pager, SuccessToast, SearchField,
} from '../ManageLayout';

import { faPlus, faSearch, faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const fetchEntities = async (page = 1, filter = '') => {
    let url = `${process.env.REACT_APP_SERVER}geo-service/manage/associations?page=${page}`;
    if (filter) url = `${url}&filter=${encodeURIComponent(filter)}`;
    return await axios.get(url);
}

function ManageAssociations() {
    const [associations, setAssociations] = useState(null);
    const [paginatorData, setPaginatorData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [filtering, setFiltering] = useState('');

    const history = useHistory();

    useEffect(() => {
        async function fetchAssociations(page = 1, filter = '') {

            const { data: { rows, pages, hasPrevious, hasNext } } = await fetchEntities(page, filter);

            setAssociations(rows);
            setPaginatorData({ pages, hasPrevious, hasNext });
        }

        if (currentPage) fetchAssociations(currentPage, filtering);
    }, [currentPage, filtering]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    const handleEdit = (id) => {
        history.push(`/associacoes/gerenciar/${id ? id : ''}`);
    }

    const handleClose = () => {
        history.push('/associacoes');
    }

    const handleUpdate = () => {
        doToast('Os dados da associação foram gravados!');
        handleClose();
        refresh();
    }

    const handleStatus = () => {
        doToast('O status da associação foi atualizado!');
        refresh();
    }

    const doToast = (message) => {
        setToastMessage(message);
        setShowToast(true);
    }

    const refresh = () => {
        // TODO: best practices
        const currentPageCopy = currentPage;
        setCurrentPage(null);
        setCurrentPage(currentPageCopy);
    }

    const handleFilter = (filter) => {
        setCurrentPage(1);
        setFiltering(filter);
    }

    return <>
        <List
            currentPage={currentPage}
            associations={associations}
            paginatorData={paginatorData}
            filtering={filtering}
            handlePageChange={handlePageChange}
            handleEdit={handleEdit}
            handleFilter={handleFilter}
        />

        <Route path="/associacoes/gerenciar/:id?" render={({ match }) => (
            <Manage
                key={match.params.id || 'new'}
                id={match.params.id}
                row={associations && associations.find((assoc) => String(assoc.id) === match.params.id)}
                onUpdate={handleUpdate}
                onStatus={handleStatus}
                onClose={handleClose}
            />
        )} />

        <SuccessToast show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
    </>;
}

function Manage({ id, row, onUpdate, onStatus, onClose }) {
    const [data, setData] = useState({
        nome: '',
    });

    const [status, setStatus] = useState(null);
    const [changingStatus, setChangingStatus] = useState(false);

    useEffect(() => {
        async function fetchAssociation(id) {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/associations/${id}`);
            setData(data);
        }

        if (id) fetchAssociation(id);
    }, [id]);

    const currentStatus = status || data.status || (row && row.status) || null;

    const toggleStatus = async () => {
        const next = currentStatus === 'ativo' ? 'inativo' : 'ativo';

        setChangingStatus(true);
        try {
            await axios.put(`${process.env.REACT_APP_SERVER}geo-service/manage/assocs/${id}/${next}`);
            setStatus(next);
            onStatus();
        } catch (e) {
            console.log(e);
        }
        setChangingStatus(false);
    }

    return (
        <SideDrawer title={id ? 'Associação' : 'Nova associação'} onClose={onClose}>
            {id && <>
                <Identity>
                    <ColorSwatch style={{ backgroundColor: data.color || '#e5e7eb' }} />
                    <div>
                        <strong>{data.nome || 'Carregando...'}</strong>
                        <small>{currentStatus ? <StatusDot className={currentStatus === 'ativo' ? 'success' : 'muted'}>{currentStatus === 'ativo' ? 'Ativa' : 'Inativa'}</StatusDot> : '-'}</small>
                    </div>
                </Identity>

                <StatusActions>
                    <Button variant="outline-secondary" size="sm" onClick={toggleStatus} disabled={!currentStatus || changingStatus}>
                        <FontAwesomeIcon icon={currentStatus === 'ativo' ? faToggleOff : faToggleOn} /> {currentStatus === 'ativo' ? 'Desativar associação' : 'Ativar associação'}
                    </Button>
                </StatusActions>
            </>}

            <ManageMain id={id} data={data} onUpdate={onUpdate} onClose={onClose} />
        </SideDrawer>
    );
}

function ManageMain({ id, data, onUpdate, onClose }) {
    const [saving, setSaving] = useState(false);

    const validate = async values => {
        const errors = {};

        if (!values.nome) {
            errors.nome = 'O NOME deve ser preenchido';
        }

        // tentando criar usuário (email está preenchido) sem preencher senha
        if(!values.uid && !!values.email.trim().length && !values.password.trim().length) errors.password = 'a SENHA deve ser preenchida';

        // já tem usuário e está enviando um email vazio
        if(!!values.uid && !values.email.trim().length) errors.email = 'o E-MAIL deve ser preenchido';

        return errors;
    };

    const save = async (data) => {
        setSaving(true);

        const { data: { savedId } } = await axios.post(`${process.env.REACT_APP_SERVER}geo-service/manage/associations/${id ? id : ''}`, data);

        setSaving(false);

        onUpdate(!id ? savedId : null);
    }

    return (
        <Formik
            validate={validate}
            onSubmit={save}
            enableReinitialize={true}
            initialValues={{
                nome: data.nome ? data.nome : '',
                color: data.color || '#000000',
                uid: data.uid,
                email: data.email || '',
                password: data.uid ? '                             ' : '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
            }) => (
                <Form noValidate onSubmit={(e) => { handleSubmit(e); }}>
                    <Row>
                        <Col sm={9}>
                            <Form.Group>
                                <Form.Label>Nome*</Form.Label>
                                <Form.Control name="nome" placeholder="Digite o NOME da associação" value={values.nome} onChange={handleChange} isValid={touched.nome && !errors.nome} isInvalid={!!errors.nome} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.nome}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col sm={3}>
                            <Form.Group>
                                <Form.Label htmlFor="colorInput">Cor</Form.Label>
                                <Form.Control
                                    type="color"
                                    id="colorInput"
                                    value={values.color}
                                    title="Escolha uma cor"
                                    name="color"
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>E-mail de acesso</Form.Label>
                                <Form.Control name="email" placeholder="E-mail para acesso da associação" value={values.email} onChange={handleChange} isValid={touched.email && !errors.email} isInvalid={!!errors.email} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Senha de acesso</Form.Label>
                                <Form.Control name="password" type='password' placeholder="Senha para acesso da associação" value={values.password} onChange={handleChange} isValid={touched.password && !errors.password} isInvalid={!!errors.password} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.password}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>

                    <FormActions>
                        <Button variant="outline-secondary" onClick={onClose}>
                            Cancelar
                        </Button>
                        <PrimaryButton type="submit" disabled={saving}>
                            {saving ? 'Gravando...' : (id ? 'Salvar alterações' : 'Cadastrar associação')}
                        </PrimaryButton>
                    </FormActions>
                </Form>
            )}
        </Formik>
    );
}

function List({ currentPage, associations, filtering, paginatorData, handleEdit, handleFilter, handlePageChange }) {
    const editing = useRouteMatch('/associacoes/gerenciar/:id?');
    const selectedId = editing ? editing.params.id : null;

    const [filter, setFilter] = useState(filtering || '');

    return (<Container>
        <Header>
            <div>
                <h4>Gestão de Associações</h4>
                <small>Associações e cooperativas, com a cor usada no mapa e o acesso ao sistema</small>
            </div>
            <HeaderActions>
                <PrimaryButton onClick={() => handleEdit()}>
                    <FontAwesomeIcon icon={faPlus} /> Nova associação
                </PrimaryButton>
            </HeaderActions>
        </Header>

        <Panel>
            <Toolbar>
                <SearchField
                    icon={faSearch}
                    placeholder="Buscar associação pelo nome..."
                    value={filter}
                    onChange={setFilter}
                    onSearch={handleFilter}
                    active={!!filtering}
                />
            </Toolbar>

            <TableScroll>
                <ListTable>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!associations && <tr><CenteredTD colSpan={2}>Carregando...</CenteredTD></tr>}
                        {associations && associations.length === 0 && <tr><CenteredTD colSpan={2}>Nenhuma associação encontrada!</CenteredTD></tr>}
                        {associations && associations.map((row) => <StyledTR
                            key={row.id}
                            className={`clickable ${row.status === 'inativo' ? 'inactive' : ''} ${String(row.id) === selectedId ? 'selected' : ''}`}
                            tabIndex={0}
                            onClick={() => handleEdit(row.id)}
                            onKeyDown={(e) => { if (e.key === 'Enter') handleEdit(row.id); }}
                        >
                            <td>
                                <NameCell>
                                    <ColorSwatch className="small" style={{ backgroundColor: row.color ? `#${row.color}` : '#e5e7eb' }} />
                                    <span className="name">{row.nome}</span>
                                </NameCell>
                            </td>
                            <td><StatusDot className={row.status === 'ativo' ? 'success' : 'muted'}>{row.status === 'ativo' ? 'Ativa' : 'Inativa'}</StatusDot></td>
                        </StyledTR>)}
                    </tbody>
                </ListTable>
            </TableScroll>

            <Pager currentPage={currentPage} paginatorData={paginatorData} onChangePage={handlePageChange} />
        </Panel>
    </Container>);
}

/* Styles */

const ColorSwatch = styled.span`
    flex: 0 0 auto;
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    box-shadow: inset 0 0 0 1px rgba(17, 24, 39, .08);

    &.small {
        width: 14px;
        height: 14px;
        border-radius: 4px;
    }
`;

const NameCell = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 10px;
`;

const Identity = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 8px 0 16px;

    div {
        display: flex;
        flex-direction: column;
    }

    strong {
        font-size: 16px;
        font-weight: 600;
    }

    small {
        color: #6b7280;
    }
`;

export default ManageAssociations;
